import { Button, Typography } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import React from 'react';
import { PrintOpts, usePrintOrDownload } from '../../hooks/usePrintOrDownload';
import { useTranslation } from '../../hooks/useTranslation';

export const Print = (opts: PrintOpts) => {
  const { handlePrint } = usePrintOrDownload(opts);
  const { t } = useTranslation();

  return (
    <Button
      data-print-exclude
      color="primary"
      onClick={handlePrint}
      endIcon={<PrintIcon />}
    >
      <Typography>{t('PRINT')}</Typography>
    </Button>
  );
};
